export default "__VITE_ASSET__8uaQg56b__"